import { isWeb } from "src/utils/platform";
const Keyboard = isWeb ? require('src/web/Keyboard').default : require('react-native').Keyboard;
export default Keyboard;
